import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  clearAll,
  onUserLogin,
  setErrorMessage,
  setLoading
} from "../../../config/redux/slice/authSlice";
import { postRequest } from '../../../helpers/request';
import { appApi } from '../../../utils/endpoints/appApi';
import { appUrls } from '../../../utils/urls/appUrls';
import { AuthAlert, PasswordComponent, Spinner } from '../../components';
import LinkVerificationErrorComponent from './LinkVerificationErrorComponent';
import LinkVerificationSuccessComponent from './LinkVerificationSuccessComponent';
import AuthFormWrapper from '../../layout/AuthFormWrapper';

export default function PasswordReset() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {encryted_email} = useParams()
  const {register, handleSubmit, watch, getValues, formState: {errors}} = useForm({mode: 'onTouched'})

  const [successMessage, setSuccessMessage] = useState(false)

  const {
        loading,
        errorMsg,
    } = useSelector((state) => state.authData)

  const passwordValue = watch('password')  

    useEffect(()=>{
      dispatch(clearAll({}))
    }, [])

    const onSubmit = async (data) => {
        dispatch(clearAll({}))
        const res = await postRequest(
            "",
            `${appApi.password_reset}`,
            { token: encodeURIComponent(encryted_email), ...data},
            dispatch,
            setLoading,
            "",
            setErrorMessage
        )
        if(res !== undefined && res.status < 400){
          navigate(appUrls.passwordResetSuccess)
        }
    }

    const closeAlert = () => {
        dispatch(setErrorMessage({message: null}))
    }

  return (
    <AuthFormWrapper sub_text='Enter your new password' onHandleSubmit={handleSubmit(onSubmit)}>
        {errorMsg && <AuthAlert onClick={closeAlert} alertStyles={{width: '95%', margin: '0 auto'}} status='error'>
            {errorMsg}
        </AuthAlert>}
        <PasswordComponent
        fieldName={'password'}
        error_msg={errors.password?.message}
        label={'New Password'}
        isReq={true}
        register={register}
        patternRules={'password'}
        hasHelperText={true}
      />
      <PasswordComponent
        fieldName={'password_confirmation'}
        error_msg={errors.password_confirmation?.message}
        label={'Confirm Password'}
        isReq={true}
        register={register}
        patternRules={'password'}
        isSameAs={passwordValue}
      />
      {/* <div className="form-group col-md-12 ">
        <label htmlFor='password'>Password</label>
        <input 
          type="password" 
          className="form-control input-lg" 
          id="password"
          {...register("password", {
            required: {
              value: true,
              message: '*this field is required'
            },
            pattern: {
              value: 'password',
              message: '*invalid password pattern'
            }
          })
        }
        />
        {
          errors?.password?.message ?
          <div className="text-danger small mt-1">
            {errors?.password?.message}
          </div> :
          <span style={{fontSize: '0.815rem'}} className="mt-2 d-block">Note: Password must be at least 8 character long and include at least 1 Upper case, 1 Digit</span>
        }
      </div>
      <div className="form-group col-md-12 ">
        <label htmlFor='password_confirmation'>Confirm Password</label>
        <input 
          type="password" 
          className="form-control input-lg" 
          id="password_confirmation"
          {...register("password_confirmation", {
            required: {
              value: true,
              message: '*this field is required'
            },
            validate: value => value === getValues('password') || "Passwords does not match"
          })
        }
        />
        {
          errors?.password_confirmation?.message &&
          <div className="text-danger small mt-1">
            {errors?.password_confirmation?.message}
          </div>
        }
      </div> */}
      <div className="col-md-12">

        <div>
          {loading ? 
            <Spinner/> :
            <button type="submit" className="btn btn-primary mb-4">Submit</button>
          }
        </div>

        <p>
          <Link className="text-blue" to={appUrls.login}>Back to Login</Link>
          {/* <a className="text-blue" href="sign-up.html">Register Here</a> */}
        </p>
      </div>
    </AuthFormWrapper>
  )
}
